function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const swatches = document.querySelectorAll('.product-card .product-card-swatches .swatch-item');
if (swatches) {
  swatches.forEach((swatch) => {
    swatch.addEventListener('click', (e) => {
      const swatch = e.target;
      const swatchId = swatch.getAttribute('data-swatch-id');
      const productCard = swatch.closest('.product-card');

      // set active state for chosen swatch
      productCard.querySelectorAll('.product-card-swatches .swatch-item').forEach(type => type.classList.remove('active'));
      productCard.querySelector(`.product-card-swatches .swatch-item[data-swatch-id="${swatchId}"]`).classList.add('active');

      productCard.querySelectorAll('.product-card-types .variant-img').forEach(type => type.classList.remove('active'));
      const variant = productCard.querySelector(`.product-card-types .variant-img[data-variant-id="${swatchId}"]`);
      if(variant) {
        variant.classList.add('active');
      }

      productCard.querySelectorAll('.product-card-price .variant-price').forEach(type => type.classList.remove('active'));
      productCard.querySelector(`.product-card-price .variant-price[data-variant-id="${swatchId}"]`).classList.add('active');

      const title = e.target.querySelector(`.visually-hidden`).textContent;
      const url = e.target.dataset.url;

      productCard.querySelector(`.product-card-title a`).href = url;
      productCard.querySelector(`.product-card-title a`).innerHTML = title;
    });
  });
}

const productTabsNav = document.querySelectorAll('.product-recommendation-tabs .tabs-nav .tab-link');
if (productTabsNav) {
  productTabsNav.forEach(tab => {
    tab.addEventListener('click', (e) => {
      e.preventDefault();

      let product = tab.closest('.product-recommendation');
      let target = tab.getAttribute('href').replace('#', '');

      // remove 'active' class from all tab links
      product.querySelectorAll('.tab-link').forEach(item => item.classList.remove('active'));
      product.querySelectorAll('.tab-item').forEach(item => item.classList.remove('active'));

      // add 'active' class for this tab link
      tab.classList.add('active');
      document.getElementById(target).classList.add('active');
    });
  });
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    // update product summary on product page
    if (document.querySelector('.single-product')) {
      document.querySelector('.product-summary-quantity span').innerHTML = this.input.value;
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange.bind(this));
    this.getBadgeOnLoad();
  }

  getBadgeOnLoad() {
    const url = window.location.href;
    const urlObj = new URL(url);

    const variant = urlObj.searchParams.get('variant');

    if(variant) {
      this.showBadges(variant);
    } else {
      const firstBadge = document.querySelector('.badges-list-wrapper');
      if(firstBadge) {
        firstBadge.classList.add('active');
      }
    }
  }

  onVariantChange(e) {
    this.updateOptions();
    this.updateMasterId();
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.resetQuantity();
      this.updateURL();
      this.updateVariantInput();
      this.updateSummary();
      this.renderProductInfo();
      this.updateBtnText();
      this.showBadges();
    }
  }

  showBadges(variant = null) {
    if(variant) {
      const activeBadge = document.querySelector(`#badge${variant}`);
  
      if(activeBadge) {
        activeBadge.classList.add('active');
      }
    } else {
      const badgesLists = document.querySelectorAll('.badges-list-wrapper');

      badgesLists.forEach(badgesList => {
        badgesList.classList.remove('active');
      });
  
      const activeBadge = document.querySelector(`#badge${this.currentVariant.id}`);
  
      if(activeBadge) {
        activeBadge.classList.add('active');
      }
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  resetQuantity() {
    document.querySelector('quantity-input .quantity__input').value = 1;
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-set-form-${this.dataset.section}`);
    
    productForms.forEach(productForm => {
      let input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateSummary() {
    const form = this.closest('form[action="/cart/add"]');
    if (!form) return;

    const summaryVariants = form.querySelector('.product-summary-variants');
    if (summaryVariants) {
      summaryVariants.innerHTML = this.currentVariant.title.replace(' /', ',');
    }
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  updateBtnText() {
    const form = this.closest('form[action="/cart/add"]');
    if (!form) return;

    const btns = form.querySelectorAll('#AddToCart, .add-to-cart__button-label');

    const scriptElement = document.querySelector('script.skus');
    if (!scriptElement) return;

    const jsonText = scriptElement.textContent || scriptElement.innerText || '""';
    let skusArray = [];

    try {
      skusArray = JSON.parse(jsonText);
    } catch (error) {
      return;
    }
  
    if (!Array.isArray(skusArray) || skusArray.length === 0) {
      return;
    }
  
    if (this.currentVariant && skusArray.includes(this.currentVariant.sku)) {
      btns.forEach(btn => {
        btn.querySelector('.meta').innerHTML = `${document.querySelector('script.btn-text').textContent} —`;
      });
    } else {
      btns.forEach(btn => {
        btn.querySelector('.meta').innerHTML = `${window.variantStrings.addToCart} —`;
      });
    }
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');

        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.querySelector(`.single-product__price .price-wrapper`);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);
        const priceValue = price.querySelector('.price').getAttribute('data-price');

        if (price) price.classList.remove('visibility-hidden');
        const status = this.currentVariant && this.currentVariant.available != undefined ? this.currentVariant.available : false;
        this.toggleAddButton(!status, window.variantStrings.soldOut, true, priceValue);
        this.updateBtnText();
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true, price = false) {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-set-form-${this.dataset.section}`);
    if (!productForms) return;

    productForms.forEach(productForm => {
      const addButton = productForm.querySelector('[name="add"]');
      const addButtonInside = productForm.querySelector('[name="add"] > .meta');
      
      if (!addButton) return;

      if (disable) {
        addButton.setAttribute('disabled', 'disabled');
        if (text) addButtonInside.textContent = text;
      } else {
        addButton.removeAttribute('disabled');

        if (this.dataset.mainProduct === 'false') {
          addButtonInside.textContent = window.variantStrings.addToCart;
        } else {
          addButtonInside.textContent = window.variantStrings.addToCart + ' — ';
          addButton.querySelector('.price').innerHTML = price;
        }
      }
      if(addButton)
      addButton.classList.remove("_"+window.variantStrings.unavailable);
      if (!modifyClass) return;
    });
  }

  setUnavailable() {
    const buttons = document.querySelectorAll(`#product-form-${this.dataset.section}`, `#product-set-form-${this.dataset.section}`);

    buttons.forEach(button => {
      let addButton = button.querySelector('[name="add"]');
      let addButtonText = button.querySelector('[name="add"] > span');
      let price = document.getElementById(`price-${this.dataset.section}`);
      if (!addButton) return;
      addButtonText.textContent = window.variantStrings.unavailable;
      addButton.classList.add("_"+window.variantStrings.unavailable);
      if (price) price.classList.add('visibility-hidden');
    })
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    
    console.log("listOfAvailableOptions",listOfAvailableOptions);
    listOfOptions.forEach((input) => { 
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
         input.classList.remove('disabled');
        input.disabled = false;
      } else {
       input.classList.add('disabled');
       input.disabled = true;
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
    // console.log(this.options)
  }
}

customElements.define('variant-radios', VariantRadios);

class Animation {
  constructor() {
    this.aEls = document.querySelectorAll('.al');
    if(!this.aEls.length) {
      return;
    }
    this.addEventListeners();
  }
  checkViewport(el) {
    let bounding = el.getBoundingClientRect();
    if (bounding.top >= -bounding.height + 50
      && bounding.bottom - 50 <= (window.innerHeight || document.documentElement.clientHeight) + bounding.height ) {
      el.classList.add('active');
    }
  }
  debounce(fn, ms) {
    let timeout;
    return (...args) => {
      const later = () => {
        timeout = null;
        fn(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, ms);
    };
  }
  checkAllElements() {
    for (let i = 0; i < this.aEls.length; i++) {
      this.checkViewport(this.aEls[i]);
    }
  }
  addEventListeners() {
    const debouncedCheck = this.debounce(this.checkAllElements.bind(this), 25);
    ['resize', 'scroll'].forEach(event => window.addEventListener(event, debouncedCheck));
    this.checkAllElements();
  }
}
new Animation();

class Parallax {
  constructor() {
    this.pEls = document.querySelectorAll('.parallax');
    if (!this.pEls.length) {
      return;
    }
    this.addEventListeners();
  }
  applyParallax() {
    this.pEls.forEach(el => {
      let bounding = el.getBoundingClientRect();
      if (bounding.top < window.innerHeight && bounding.bottom > 0) {
        let scrollProgress = Math.min(1, (window.innerHeight - bounding.top) / (bounding.height + window.innerHeight));
        scrollProgress = Math.max(0, scrollProgress);
        let translateY = (scrollProgress * 100 - 50);
        let parallaxSpeed = 0.125;
        el.style.transform = `scale(1.2) translateY(${translateY * parallaxSpeed}%)`;
      }
    });
  }
  addEventListeners() {
    window.addEventListener('scroll', () => this.applyParallax());
    this.applyParallax();
  }
}
new Parallax();



class ModifyIframe {
  constructor() {
    this.number = 0;
    window.addEventListener('load', () => {
      this.chatContainer = document.getElementById('gorgias-chat-container'); 
      this.modifyIframeOnLoad();
    });
  }

  modifyIframeOnLoad() {
    let iframe = document.getElementById('chat-button');
    if (iframe) {
      var innerDoc = iframe.contentDocument || iframe.contentWindow.document;
      var buttons = innerDoc.querySelectorAll('button');
      buttons.forEach(function (button) {
        button.style.padding = '0';
        button.style.background = 'transparent';
        button.style.boxShadow = 'none';
      });
      buttons.forEach(function (svg, index) {
        svg.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="65" height="66" viewBox="0 0 65 66" fill="none"> <path d="M24.5771 28.7753C24.5771 24.1217 22.2646 21 17.5822 21C12.8999 21 9.38795 26.463 12.1482 30.3362" stroke="#67524C"/> <path d="M24.5771 28.4574C24.5771 35.8281 17.5822 31.926 17.5822 39.7302L17.5822 41.6813" stroke="#67524C"/> <path d="M17.4867 44.5H17.5133C17.7821 44.5 18 44.7179 18 44.9867V45.0133C18 45.2821 17.7821 45.5 17.5133 45.5H17.4867C17.2179 45.5 17 45.2821 17 45.0133V44.9867C17 44.7179 17.2179 44.5 17.4867 44.5Z" fill="#67524C" stroke="#67524C"/> <circle cx="32.5" cy="33" r="29.5" fill="#FAF5E9" stroke="#9B877C"/> <path d="M25.121 42.2505C18.451 42.2505 13.0889 36.6268 13.5248 29.8551C13.9172 23.6792 19.3229 19 25.5134 19H40.6989C46.8893 19 52.2951 23.6792 52.7019 29.8551C53.1379 36.6268 47.7757 42.2505 41.1057 42.2505H34.9153C33.7528 42.2505 32.6484 42.701 31.8346 43.5293L25.121 50.2429" stroke="#67524C" stroke-linejoin="round"/> <path d="M35.9336 27.7322C35.9336 25.4984 34.8236 24 32.576 24C30.3285 24 28.6428 26.6222 29.9677 28.4814" stroke="#67524C"/> <path d="M35.9336 27.5795C35.9336 31.1175 32.576 29.2445 32.576 32.9905L32.576 33.927" stroke="#67524C"/> <path d="M32.4867 35.5H32.5133C32.7821 35.5 33 35.7179 33 35.9867V36.0133C33 36.2821 32.7821 36.5 32.5133 36.5H32.4867C32.2179 36.5 32 36.2821 32 36.0133V35.9867C32 35.7179 32.2179 35.5 32.4867 35.5Z" fill="#67524C" stroke="#67524C"/> </svg>';
      });
      iframe.style.opacity = '1';
    } else if (this.number < 10) {
      this.number++;
      setTimeout(() => this.modifyIframeOnLoad(), 500); 
    }
  }
}

new ModifyIframe();




class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('ul'),
    };
    this.elements.button.addEventListener('click', this.openSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  openSelector() {
    this.elements.button.focus();
    this.elements.panel.toggleAttribute('hidden');
    this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
  }
}
customElements.define('localization-form', LocalizationForm);


class FancyLanguage {
  constructor() {
    this.languageItem = document.querySelector('.language-switcher'); 
    this.el = '.fancybox__carousel .language-modal';
    if (this.languageItem) {
      this.observeDOMChanges();
    }
  }

  observeDOMChanges() {
    const observer = new MutationObserver(mutations => {
      for (const mutation of mutations) {
        if (mutation.type === 'childList') {
          for (const node of mutation.addedNodes) {
            if (node.nodeType === 1 && node.matches(this.el)) {
              this.handleNewElement(node);
            }
          }
        }
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
  handleNewElement(el) {
    const closestCarousel = el.closest('.fancybox__carousel');
    if (closestCarousel) {
      const fancyboxNav = closestCarousel.querySelector('.fancybox__nav');
      if (fancyboxNav) {
        fancyboxNav.remove();
      }
    }
  }
}

new FancyLanguage();